// Masanın QR menyu kodu.
//
// İKİ XƏTA BURADA DÜZƏLDİLDİ:
//
//  1. POS rejimində masa id-si `tbl_5` formatındadır (pos_local), cloud endpoint-i
//     isə numerik id gözləyir → `findOrFail('tbl_5')` 404 verirdi və QR heç vaxt
//     yaranmırdı. İndi prefiks təmizlənir.
//
//  2. Masaya heç vaxt QR yaradılmayıbsa `unique_url` NULL gəlir. Köhnə kod bunu
//     boş sətir kimi qəbul edib `.../order-details/` linkini QR-a yazırdı —
//     yəni SINIQ kod çap olunurdu. İndi boş olduqda avtomatik
//     `POST /qr/generate/:id` çağırılır, yenə boş qalsa xəta göstərilir.

import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import axios from 'axios';
import { base_url, domain_url } from '../api/index';
import { useI18n } from '../i18n/I18nContext';

const getHeaders = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

/** `tbl_5` → `5`. Cloud QR endpoint-i yalnız numerik masa id-si qəbul edir. */
const toCloudTableId = (raw: string | number): string =>
  String(raw ?? '').replace(/^tbl_/, '');

/** Cavabın hansı formada gəldiyindən asılı olmayaraq token-i çıxar. */
const readToken = (data: any): string => {
  if (typeof data === 'string') return data;
  return data?.unique_url || data?.token || data?.data?.unique_url || '';
};

function QrMenuKod({ tableId }) {
  const { t } = useI18n();
  const [link, setLink] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const cloudId = toCloudTableId(tableId);
    if (!cloudId) {
      setError(t('qr.fetchError'));
      return;
    }

    let cancelled = false;

    const fetchToken = async () => {
      try {
        const response = await axios.get(`${base_url}/qr/${cloudId}`, getHeaders());
        let token = readToken(response.data);

        // Masaya hələ QR yaradılmayıb — indi yarat.
        if (!token) {
          const generated = await axios.post(
            `${base_url}/qr/generate/${cloudId}`,
            {},
            getHeaders(),
          );
          token = readToken(generated.data);
        }

        if (cancelled) return;

        if (!token) {
          setError(t('qr.generateError'));
          return;
        }

        setError('');
        setLink(`${domain_url}/order-details/${token}`);
      } catch (err: any) {
        if (cancelled) return;
        console.error('QR kodu alınmadı:', err);
        setError(
          err?.response?.status === 403 ? t('qr.forbidden') : t('qr.fetchError'),
        );
      }
    };

    fetchToken();
    return () => {
      cancelled = true;
    };
  }, [tableId, t]);

  return (
    <div className='border rounded bg-gray-50 m-4 p-3'>
      {error && <div className="text-red-500 mb-3">{error}</div>}
      {link ? (
        <>
          <QRCode value={link} size={110} />
          <input
            type="text"
            className='form-item w-full my-3 bg-white'
            value={link}
            readOnly
          />
          <button className='border w-full rounded py-2 px-3 text-sm font-medium mb-3 text-start'>
            {t('qr.saveHint')}
          </button>
        </>
      ) : (
        !error && <div>{t('exp.loading')}</div>
      )}
    </div>
  );
}

export default QrMenuKod;
